import { requestPrint } from '@/libs/bixolon/bxlcommon'
import { cutPaper, getPosData } from '@/libs/bixolon/bxlpos'
import { printLine, printTotals } from '@/libs/bixolon/printer'
import { resolveAttributeValue, effectiveManualValue } from '@/modules/company/components/declarations/declarationsService.js'
import state from '@/state'
import * as JSPM from 'jsprintmanager'

const viewResult = (result) => {
  if (result === 'Cannot connect to server') {
    alert('Pisač je nedostupan.')
  }
}

export const printDeclarationToPos = async (item, fields, printerConfiguration) => {
  // Fix za staru konfiguraciju (isto kao order.js)
  if (!['UNIVERSAL', 'NONE'].includes(state.getPrinterLib())) {
    if (!printerConfiguration.font) printerConfiguration.font = 0
    if (!printerConfiguration.size) printerConfiguration.size = 0
    if (!printerConfiguration.width) printerConfiguration.width = '80'
    if (!printerConfiguration.line_length) printerConfiguration.line_length = 48
    if (!printerConfiguration.library) printerConfiguration.library = 'BIXOLON'
  }

  let [escpos, doc] = [null, null]

  if (printerConfiguration.library === 'UNIVERSAL') {
    if (window.Neodynamic && window.Neodynamic.JSESCPOSBuilder) {
      escpos = window.Neodynamic.JSESCPOSBuilder
      doc = new escpos.Document()
    } else {
      return { success: false, error: 'UNIVERSAL library not available' }
    }
  }

  const options = {
    horizontal: 0,
    vertical: 0,
    bold: false,
    invert: false,
    underline: false,
    alignment: 0,
    lineSpacing: 1,
    printerConfiguration,
    document: doc,
    escpos
  }

  // Convert font to numeric values for BIXOLON library, keep string values for UNIVERSAL
  if (printerConfiguration.library === 'UNIVERSAL') {
    options.font = printerConfiguration.font
  } else if (printerConfiguration.font === 'A') {
    options.font = 0
  } else if (printerConfiguration.font === 'B') {
    options.font = 1
  } else if (printerConfiguration.font === 'C') {
    options.font = 2
  }

  printLine(item.name, { ...options, bold: true, alignment: 1 })

  const printableFields = fields
    .filter(f => f.printaj && !f.removed)
    .sort((a, b) => (a.column - b.column) || (a.order - b.order))

  printableFields.forEach(field => {
    const value = field.type === 'attribute'
      ? resolveAttributeValue(item, field.attribute_field)
      : effectiveManualValue(field)
    if (!value) return
    printTotals(field.label, value, options)
  })

  try {
    if (printerConfiguration.library === 'UNIVERSAL') {
      doc.cut()
      const escposCommands = options.document.generateUInt8Array()
      const cpj = new JSPM.ClientPrintJob()

      let selectedPrinter
      if (printerConfiguration.ip_address && printerConfiguration.ip_address !== '') {
        const port = (printerConfiguration.port && printerConfiguration.port !== 9100) ? printerConfiguration.port : 9100
        selectedPrinter = new JSPM.NetworkPrinter(port, printerConfiguration.ip_address)
      } else {
        selectedPrinter = new JSPM.InstalledPrinter(printerConfiguration.printer_name)
      }

      cpj.clientPrinter = selectedPrinter
      cpj.binaryPrinterCommands = escposCommands
      await cpj.sendToClient()
      return { success: true }
    } else if (state.getPrinterLib() === 'BIXOLON80') {
      cutPaper()
      const strSubmit = getPosData()
      await requestPrint(printerConfiguration.printer_name, strSubmit, viewResult, printerConfiguration.ip_address)
      return { success: true }
    }
  } catch (err) {
    return { success: false, error: err.message || 'Unknown error' }
  }

  return { success: false, error: 'No matching printer library configured' }
}
